/**
 * @name header
 */
import base from '../../base';
import Header from './header';

Header.install = function(Vue) {
  Vue.use(base);
  Vue.component(Header.name, Header);
};

export default Header;
